import { Button, Input, Popover, PopoverContent, PopoverTrigger } from "@devhop/ui";
import * as LucideIcons from "lucide-react";
import { Search, X } from "lucide-react";
import { useState, useMemo } from "react";
import { cn } from "@devhop/ui";

// Common icons for form categories
const COMMON_ICONS = [
  "Folder",
  "FileText",
  "Document",
  "File",
  "FolderOpen",
  "Archive",
  "Briefcase",
  "Clipboard",
  "ClipboardList",
  "FileCheck",
  "FileEdit",
  "FileQuestion",
  "FileSearch",
  "FileX",
  "Files",
  "FolderCheck",
  "FolderEdit",
  "FolderPlus",
  "FolderSearch",
  "Inbox",
  "Package",
  "PackageCheck",
  "PackageSearch",
  "PackageX",
  "Book",
  "BookOpen",
  "Bookmark",
  "Calendar",
  "CalendarCheck",
  "CalendarDays",
  "CalendarX",
  "CheckSquare",
  "CheckCircle",
  "Circle",
  "Square",
  "List",
  "ListChecks",
  "ListTodo",
  "Grid",
  "Layout",
  "LayoutGrid",
  "LayoutList",
  "BarChart",
  "BarChart2",
  "BarChart3",
  "LineChart",
  "PieChart",
  "TrendingUp",
  "TrendingDown",
  "Activity",
  "Target",
  "Flag",
  "Tag",
  "Tags",
  "Star",
  "Heart",
  "ThumbsUp",
  "MessageSquare",
  "MessageCircle",
  "Mail",
  "Send",
  "Bell",
  "BellRing",
  "Settings",
  "Cog",
  "Wrench",
  "Tool",
  "Hammer",
  "Key",
  "Lock",
  "Unlock",
  "Shield",
  "ShieldCheck",
  "AlertCircle",
  "AlertTriangle",
  "Info",
  "HelpCircle",
  "QuestionMarkCircle",
  "Check",
  "X",
  "Plus",
  "Minus",
  "Edit",
  "Trash",
  "Save",
  "Download",
  "Upload",
  "Share",
  "Copy",
  "Cut",
  "Paste",
  "Refresh",
  "RotateCw",
  "RotateCcw",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "ChevronDown",
  "Home",
  "User",
  "Users",
  "UserPlus",
  "UserCheck",
  "UserX",
  "Building",
  "Building2",
  "MapPin",
  "Globe",
  "Link",
  "Image",
  "ImageIcon",
  "Video",
  "Music",
  "Film",
  "Camera",
  "Printer",
  "Monitor",
  "Laptop",
  "Smartphone",
  "Tablet",
  "Database",
  "Server",
  "Cloud",
  "CloudUpload",
  "CloudDownload",
  "Wifi",
  "Zap",
  "Battery",
  "BatteryCharging",
  "Power",
  "Sun",
  "Moon",
  "Lightbulb",
  "Flashlight",
  "Flame",
  "Droplet",
  "Wind",
  "Snowflake",
  "Umbrella",
  "Tree",
  "Leaf",
  "Flower",
  "Bug",
  "Fish",
  "Cat",
  "Dog",
  "Bird",
  "Car",
  "Bike",
  "Plane",
  "Ship",
  "Train",
  "Bus",
  "Truck",
  "ShoppingCart",
  "CreditCard",
  "Wallet",
  "Banknote",
  "Coins",
  "Receipt",
  "Ticket",
  "Gift",
  "Cake",
  "Coffee",
  "Utensils",
  "Apple",
  "Banana",
  "Cherry",
  "Grape",
  "Lemon",
  "Orange",
  "Strawberry",
  "Pizza",
  "IceCream",
  "Cookie",
  "Candy",
  "Beer",
  "Wine",
  "Glass",
  "Bottle",
  "Mug",
  "Cup",
  "Bowl",
  "Plate",
  "ForkKnife",
  "ChefHat",
  "Store",
  "ShoppingBag",
  "Package",
  "Box",
  "Container",
  "Palette",
  "Paintbrush",
  "Brush",
  "Pen",
  "Pencil",
  "Highlighter",
  "Eraser",
  "Ruler",
  "Compass",
  "Triangle",
  "Circle",
  "Square",
  "Hexagon",
  "Octagon",
  "Diamond",
  "Star",
  "Heart",
  "Smile",
  "Frown",
  "Meh",
  "Laugh",
  "Angry",
  "Surprise",
  "Wink",
  "Tongue",
  "Eye",
  "Eyes",
  "Ear",
  "Nose",
  "Mouth",
  "Hand",
  "Handshake",
  "ThumbsUp",
  "ThumbsDown",
  "PointingUp",
  "PointingDown",
  "PointingLeft",
  "PointingRight",
  "Fist",
  "Peace",
  "Victory",
  "Ok",
  "Rock",
  "Paper",
  "Scissors",
  "Dice1",
  "Dice2",
  "Dice3",
  "Dice4",
  "Dice5",
  "Dice6",
  "Gamepad",
  "Gamepad2",
  "Joystick",
  "Controller",
  "Play",
  "Pause",
  "Stop",
  "SkipBack",
  "SkipForward",
  "FastForward",
  "Rewind",
  "Repeat",
  "Shuffle",
  "Volume",
  "Volume1",
  "Volume2",
  "VolumeX",
  "VolumeMute",
  "Headphones",
  "Radio",
  "Tv",
  "Tv2",
  "Computer",
  "Mouse",
  "Keyboard",
  "MousePointer",
  "MousePointer2",
  "Cursor",
  "CursorClick",
  "HandPointer",
  "Move",
  "Move3d",
  "Rotate",
  "Scale",
  "Resize",
  "Maximize",
  "Minimize",
  "Maximize2",
  "Minimize2",
  "Expand",
  "Shrink",
  "Fullscreen",
  "FullscreenExit",
  "AspectRatio",
  "Crop",
  "Scissors",
  "Cut",
  "Copy",
  "Paste",
  "Undo",
  "Redo",
  "RotateCw",
  "RotateCcw",
  "FlipHorizontal",
  "FlipVertical",
  "Mirror",
  "Reflect",
  "AlignLeft",
  "AlignRight",
  "AlignCenter",
  "AlignJustify",
  "AlignVerticalJustifyCenter",
  "AlignVerticalJustifyStart",
  "AlignVerticalJustifyEnd",
  "AlignHorizontalJustifyCenter",
  "AlignHorizontalJustifyStart",
  "AlignHorizontalJustifyEnd",
  "Bold",
  "Italic",
  "Underline",
  "Strikethrough",
  "Subscript",
  "Superscript",
  "Code",
  "Code2",
  "Terminal",
  "Command",
  "Hash",
  "AtSign",
  "Percent",
  "Asterisk",
  "Plus",
  "Minus",
  "Divide",
  "Equal",
  "NotEqual",
  "GreaterThan",
  "LessThan",
  "GreaterThanOrEqual",
  "LessThanOrEqual",
  "Infinity",
  "Pi",
  "Omega",
  "Alpha",
  "Beta",
  "Gamma",
  "Delta",
  "Epsilon",
  "Zeta",
  "Eta",
  "Theta",
  "Iota",
  "Kappa",
  "Lambda",
  "Mu",
  "Nu",
  "Xi",
  "Omicron",
  "Rho",
  "Sigma",
  "Tau",
  "Upsilon",
  "Phi",
  "Chi",
  "Psi",
  "Omega",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
] as const;

type IconName = (typeof COMMON_ICONS)[number];

interface IconPickerProps {
  value?: string;
  onChange: (value: string) => void;
  className?: string;
}

export function IconPicker({ value, onChange, className }: IconPickerProps) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filteredIcons = useMemo(() => {
    if (!search.trim()) return COMMON_ICONS;
    const searchLower = search.toLowerCase();
    return COMMON_ICONS.filter((icon) =>
      icon.toLowerCase().includes(searchLower),
    );
  }, [search]);

  const SelectedIcon = value
    ? (LucideIcons[value as keyof typeof LucideIcons] as
        | React.ComponentType<{ className?: string }>
        | undefined)
    : null;

  const handleSelect = (iconName: string) => {
    onChange(iconName);
    setOpen(false);
    setSearch("");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className={cn("w-full justify-start", className)}
        >
          {SelectedIcon ? (
            <>
              <SelectedIcon className="mr-2 h-4 w-4" />
              <span className="flex-1 text-left">{value}</span>
            </>
          ) : (
            <span className="text-muted-foreground">ເລືອກໄອຄອນ...</span>
          )}
          {value && (
            <X
              className="ml-2 h-4 w-4"
              onClick={(e) => {
                e.stopPropagation();
                onChange("");
              }}
            />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[400px] p-0" align="start">
        <div className="border-b p-2">
          <div className="relative">
            <Search className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              placeholder="ຄົ້ນຫາໄອຄອນ..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-8"
            />
          </div>
        </div>
        <div className="max-h-[400px] overflow-y-auto p-2">
          <div className="grid grid-cols-8 gap-2">
            {filteredIcons.map((iconName) => {
              const IconComponent = LucideIcons[
                iconName as keyof typeof LucideIcons
              ] as React.ComponentType<{ className?: string }> | undefined;

              if (!IconComponent) return null;

              const isSelected = value === iconName;

              return (
                <button
                  key={iconName}
                  type="button"
                  onClick={() => handleSelect(iconName)}
                  className={cn(
                    "flex h-10 w-10 items-center justify-center rounded-md border transition-colors",
                    isSelected
                      ? "border-primary bg-primary text-primary-foreground"
                      : "border-border hover:bg-accent hover:text-accent-foreground",
                  )}
                  title={iconName}
                >
                  <IconComponent className="h-5 w-5" />
                </button>
              );
            })}
          </div>
          {filteredIcons.length === 0 && (
            <div className="py-8 text-center text-sm text-muted-foreground">
              ບໍ່ພົບໄອຄອນ
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
